<template>
  <div>

    <!-- HEADER & ADD-DIALOG -->
    <section class="section headerBackground">
      <div class="container headerTitle">
        <h1 class="title pageHeaderTekst">Manage Sitoo Users</h1>
        <b-button
          size="is-small is-action"
          type="is-primary"
          expanded
          icon-left="plus"
          @click="isAddUserModalActive = true">Add new user
        </b-button>
        <b-modal
          :active.sync="isAddUserModalActive"
          has-modal-card
          trap-focus
          aria-role="dialog"
          aria-modal>
          <b-modal :active.sync="isAddUserModalActive" has-modal-card>
            <form id="addUser">
              <div class="modal-card" style="margin: auto; min-width: 300px; max-width: 95%">
                <header class="modal-card-head">
                  <p class="modal-card-title">Add new user</p>
                </header>
                <section class="modal-card-body">
                  <b-field label="Email*" label-position="inside">
                    <b-input
                      type="email"
                      id="email"
                      placeholder="steve.smith@example.com"
                      @keyup.native="checkIfEmailAlreadyExists"
                      required>
                    </b-input>
                  </b-field>
                  <div :class="isEmailAvailable ? 'emailAvailabilityCheck' : 'emailAvailabilityError'">
                    <span>{{ emailFieldMessage }}</span>
                  </div>
                  <div class="extraMargin"></div>
                  <b-field label="First name*" label-position="inside">
                    <b-input name="firstname" placeholder="Steve" required></b-input>
                  </b-field>
                  <b-field label="Last name*" label-position="inside">
                    <b-input name="lastname" placeholder="Smith" required></b-input>
                  </b-field>
                  <b-field label="Personal Id" label-position="inside">
                    <b-input name="personalid" placeholder="xxxxxx-xxxx"></b-input>
                  </b-field>
                  <b-field label="Company" label-position="inside">
                    <b-input name="company" placeholder="Sitoo"></b-input>
                  </b-field>
                  <b-field label="Address" label-position="inside">
                    <b-input name="address" placeholder="Streetname 2"></b-input>
                  </b-field>
                  <b-field label="Zip" label-position="inside">
                    <b-input name="zip" placeholder="123 56"></b-input>
                  </b-field>
                  <b-field label="Country" label-position="inside">
                    <b-input name="countryid" placeholder="US"></b-input>
                  </b-field>
                </section>
                <div class="modal-card-foot" style="display: flex;">
                  <div style="flex-grow: 1;"></div>
                  <button class="button" type="button" @click="isAddUserModalActive = false">Cancel</button>
                  <button class="button is-action" type="submit">Save</button>
                </div>
              </div>
            </form>
          </b-modal>
        </b-modal>
      </div>
    </section>

    <!-- TABLE -->
    <section class="section">
      <div class="container">
        <b-table
          :data="data"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          pagination-position="bottom">
          <template slot-scope="props">
            <b-table-column field="firstName" label="First name">{{ props.row.namefirst }}</b-table-column>
            <b-table-column field="lastName" label="Last name">{{ props.row.namelast }}</b-table-column>
            <b-table-column field="email" label="E-mail">{{ props.row.email }}</b-table-column>
            <b-table-column field="company" label="Company">{{ props.row.company }}</b-table-column>
            <b-table-column
              field="lastModified"
              label="Last Modified"
            >{{ props.row.datemodified ? new Date(props.row.datemodified).toLocaleDateString() : '' }}</b-table-column>
            <b-table-column field="edit" label="Edit" centered>
              <b-button class="iconButton" @click="editUser(props.row)">
                <b-icon pack="far" icon="edit" size="is-small" class="tableIcon"></b-icon>
              </b-button>
            </b-table-column>
            <b-table-column field="delete" label="Delete" centered>
              <b-button @click="confirmCustomDelete(props.row.userid)" class="iconButton">
                <b-icon pack="fas" icon="trash" size="is-small" class="tableIcon"></b-icon>
              </b-button>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </section>

    <!-- EDIT-DIALOG -->
    <b-modal
      :active.sync="isEditUserModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal>
      <b-modal :active.sync="isEditUserModalActive" has-modal-card>
        <form id="editUser">
          <div class="modal-card" style="margin: auto; min-width: 300px; max-width: 95%">
            <header class="modal-card-head">
              <p class="modal-card-title">Edit user</p>
            </header>
            <section class="modal-card-body">
              <b-field label="Email*" label-position="inside">
                <b-input type="email" :value="editUserForm.email" disabled></b-input>
              </b-field>
              <b-field label="First name*" label-position="inside">
                <b-input :value="editUserForm.namefirst" required></b-input>
              </b-field>
              <b-field label="Last name*" label-position="inside">
                <b-input :value="editUserForm.namelast" required></b-input>
              </b-field>
              <b-field label="Company" label-position="inside">
                <b-input :value="editUserForm.company" placeholder="Tesla"></b-input>
              </b-field>
            </section>
            <div class="modal-card-foot" style="display: flex;">
              <div style="flex-grow: 1;"></div>
              <button class="button" type="button" @click="isEditUserModalActive = false">Cancel</button>
              <button class="button is-action" type="submit">Save</button>
            </div>
          </div>
        </form>
      </b-modal>
    </b-modal>
  </div>
</template>

<style scoped>
.headerBackground {
  min-height: 200px;
  background-image: url("../assets/images/headerBackgroundUsers.svg");
  background-size: cover;
}

.headerTitle {
  width: 325px;
}

.pageHeaderTekst {
  font-weight: 200;
  font-size: 2.2rem;
  color: #ff8484;
  text-align: center;
  margin-bottom: 30px;
}
</style>

<script>
import users from "../mock-data/users.json";

export default {
  data() {
    return {
      data: users.items,
      isPaginated: true,
      isPaginationSimple: false,
      currentPage: 1,
      perPage: 5,
      isAddUserModalActive: false,
      isEditUserModalActive: false,
      editUserForm: {
        email: "",
        namefirst: "",
        namelast: "",
        company: ""
      },
      isEmailAvailable: true,
      emailFieldLabel: "",
      emailFieldMessage: ""
    };
  },

  methods: {
    async loadUsers() {
      //////////////////////////////////////////////////////////////////
      /// This methode causes the following error:
      /// The value of the 'Access-Control-Allow-Origin' header in the response must not be the wildcard '*' when the request's credentials mode is 'include'.
      //////////////////////////////////////////////////////////////////
      //
      // fetch("http://localhost:8010/proxy/https://api-sandbox.mysitoo.com/v2/accounts/90316/sites/1/users.json?num=5&start=1", {
      //   credentials: 'include',
      //   mode: 'cors',
      //   headers: {
      //     // 'Access-Control-Allow-Credentials': 'true',
      //     // 'Access-Control-Allow-Origin': 'http://127.0.0.1:9000',
      //     'Authorization' : 'Basic 90316-125:pfX0Y7A2TYAlZ571IKEO7AKoXza6YlvsP8kKvAu3'
      //   }
      // })
      //   //.then(response => response.json())
      //   .then(data => {
      //     console.log(data);
      //   })
      //   .catch(error => console.error(error));
    },

    checkIfEmailAlreadyExists: function(evt) {
      this.data.find(user => {
        if (user.email === evt.target._value) {
          this.isEmailAvailable = false;
          this.emailFieldLabel = "is-danger";
          this.emailFieldMessage =
            "This e-mail address is already taken, please choose another one.";
          return true;
        } else {
          this.isEmailAvailable = true;
          this.emailFieldLabel = "is-success";
          this.emailFieldMessage = "This e-mail address is available.";
        }
      });
    },

    editUser: function(user) {
      this.editUserForm.email = user.email;
      this.editUserForm.namefirst = user.namefirst;
      this.editUserForm.namelast = user.namelast;
      this.editUserForm.company = user.company;
      this.isEditUserModalActive = true;
    },

    errorToast(errorMessage) {
      this.$buefy.snackbar.open({
        duration: 5000,
        message: errorMessage,
        type: "is-danger",
        position: "is-bottom",
        actionText: null,
        queue: false
      });
    },

    successToast(successMessage) {
      this.$buefy.snackbar.open({
        duration: 3000,
        message: successMessage,
        type: "is-info",
        position: "is-bottom",
        actionText: null,
        queue: false
      });
    },

    confirmCustomDelete(userid) {
      this.$buefy.dialog.confirm({
        title: "Delete user",
        message:
          "Are you sure you want to <b>delete</b> this user? This action cannot be undone.",
        confirmText: "Delete User",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.successToast("User deleted successful.")
      });
    }
  },

  mounted() {
    this.loadUsers();
  }
};
</script>
